var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncome = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "0l2kgj7x4a",
  x1: "77.47%",
  x2: "10.147%",
  y1: "4.307%",
  y2: "103.284%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00B59C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "52.982%",
  stopColor: "#51DBA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#92FFB5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "0b8gaj79rb",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7DFFCA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#D1FFDF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "r1nze1zrkc",
  x1: "50%",
  x2: "50%",
  y1: "-14.989%",
  y2: "235.11%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00B59C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#9BFFAB"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-522 -30) translate(522 30)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "url(#0l2kgj7x4a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 8,
  fill: "url(#0b8gaj79rb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#r1nze1zrkc)",
  d: "M10 7.643h1.667c.46 0 .833-.352.833-.786 0-.434-.373-.786-.833-.786h-.834v-.785c0-.434-.373-.786-.833-.786-.46 0-.833.352-.833.786v.927c-1.138.389-1.816 1.49-1.611 2.615C7.76 9.952 8.79 10.777 10 10.786c.46 0 .833.351.833.785 0 .434-.373.786-.833.786H8.333c-.46 0-.833.352-.833.786 0 .434.373.786.833.786h.834v.785c0 .434.373.786.833.786.46 0 .833-.352.833-.786v-.927c1.138-.389 1.816-1.49 1.611-2.615C12.24 10.048 11.21 9.223 10 9.214c-.46 0-.833-.351-.833-.785 0-.434.373-.786.833-.786z"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncome);
export default ForwardRef;